import Cards from "../components/cards";
import Navbar from "../components/navbar";
import { iProduto } from "../interfaces";
import { novidades } from "../utils/index";

const Dashboard = () => {
  return (
    <>
      <div className="wh-100">
        <Navbar />
        <div className="center">
          <Cards produtos={novidades as iProduto[]} />
        </div>
        <footer>©Todos os direitos reservados.</footer>
      </div>
    </>
  );
};

export default Dashboard;
